import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Skeleton } from "@mui/material";
import type { RefObject } from "react";
import type { TPeriod } from "store/periodStore";

import StatusPill from "./StatusPill";
import { formatDates } from "./utils";

interface PeriodTriggerProps {
    triggerRef: RefObject<HTMLDivElement>;
    currentPeriod?: TPeriod;
    currentIndex: number;
    totalPeriods: number;
    usesMultiPeriods: boolean;
    open: boolean;
    t: (key: string) => string;
    onToggle: () => void;
    onPrev: () => void;
    onNext: () => void;
}

const PeriodTrigger = ({
    triggerRef,
    currentPeriod,
    currentIndex,
    totalPeriods,
    usesMultiPeriods,
    open,
    t,
    onToggle,
    onPrev,
    onNext,
}: PeriodTriggerProps) => (
    <div ref={triggerRef} className={`period-selector ${!usesMultiPeriods ? "period-selector--single" : ""}`}>
        {!usesMultiPeriods && (
            <button
                type="button"
                onClick={onPrev}
                disabled={currentIndex <= 0}
                className="period-selector__nav-btn period-selector__nav-btn--left"
            >
                <ChevronLeft sx={{ fontSize: "0.875rem" }} />
            </button>
        )}

        <button type="button" onClick={onToggle} className="period-selector__trigger">
            <CalendarTodayOutlined sx={{ fontSize: "0.8rem", color: "#aaa" }} />

            {currentPeriod === undefined ? (
                <Skeleton variant="text" width={140} height={16} />
            ) : (
                <div className="period-selector__dates-row">
                    <span className="period-selector__date-text">{formatDates(currentPeriod)}</span>
                    <span className="period-selector__status-wrapper">
                        <StatusPill status={currentPeriod.isActive} t={t} />
                    </span>
                </div>
            )}

            {usesMultiPeriods && (
                <KeyboardArrowDown
                    sx={{ fontSize: "0.875rem", color: "#999" }}
                    className={`period-selector__chevron ${open ? "period-selector__chevron--open" : ""}`}
                />
            )}
        </button>

        {!usesMultiPeriods && (
            <button
                type="button"
                onClick={onNext}
                disabled={totalPeriods - 1 <= currentIndex}
                className="period-selector__nav-btn period-selector__nav-btn--right"
            >
                <ChevronRight sx={{ fontSize: "0.875rem" }} />
            </button>
        )}
    </div>
);

export default PeriodTrigger;
